export default __webpack_public_path__ + "static/keyvisual-mobile-f0806e0b94973b20f63aecb507858093.mp4";